import { RouteRecordRaw } from 'vue-router';
import LoginPage from '@/views/pages/authentication/LoginPage.vue';
import AppLoginPage from '@/views/pages/authentication/AppLoginPage.vue';
import UpdatePasswordPage from '@/views/pages/authentication/UpdatePasswordPage.vue';
import TwoFaAuthenticator from '@/views/pages/authentication/TwoFaAuthenticatorPage.vue';
import { useAuthStore } from '@/stores';

const routes: RouteRecordRaw[] = [
    {
        name: 'Login',
        path: '/login',
        component: LoginPage,
    },
    {
        name: 'Logout',
        path: '/logout',
        component: LoginPage,
        beforeEnter: async () => {
            useAuthStore().logout();
            return true;
        },
    },
    {
        name: 'UpdatePassword',
        path: '/update-password',
        component: UpdatePasswordPage,
    },
    {
        name: 'TwoFaAuthenticator',
        path: '/two-fa/authenticator',
        component: TwoFaAuthenticator,
    },
    {
        name: 'LoginInsideApp',
        path: '/app/login',
        component: AppLoginPage,
    },
];
export default routes;
